function initMemeProduct(root){
  if(!root||root.dataset.ready)return;
  root.dataset.ready='true';
  let controller;
  let buyNowPending=false;
  let buyNowPurchase;
  let buyNowAttempt;
  let buyNowUncertain=false;
  function restoreBuyNow(purchase){
    const button=purchase?.querySelector('[data-mmp-buy-now]');
    if(!button)return;
    purchase.removeAttribute('aria-busy');
    purchase.inert=false;
    button.disabled=buyNowUncertain;
    button.removeAttribute('aria-busy');
    button.textContent=button.dataset.idleLabel;
  }
  function initBuyNow(purchase){
    const button=purchase?.querySelector('[data-mmp-buy-now]');
    if(!button)return;
    button.dataset.idleLabel=button.textContent;
    button.hidden=false;
    button.disabled=buyNowUncertain;
    if(buyNowUncertain)showBuyNowError(purchase,button.dataset.uncertainMessage,false);
  }
  function announceBuyNow(message){
    const status=root.querySelector('[data-variant-status]');
    if(status)status.textContent=message;
  }
  function showBuyNowError(purchase,message,focus){
    const errorBox=purchase?.querySelector('.mmp-form')?.querySelector('[data-mmp-buy-now-error]');
    if(!errorBox)return;
    errorBox.querySelector('[data-mmp-buy-now-message]').textContent=message;
    errorBox.hidden=false;
    if(focus&&root.isConnected)errorBox.focus();
  }
  window.addEventListener('pagehide',()=>{
    if(!buyNowAttempt)return;
    buyNowAttempt.active=false;
    if(!buyNowAttempt.confirmed){
      buyNowUncertain=true;
      const button=buyNowPurchase?.querySelector('[data-mmp-buy-now]');
      if(button)showBuyNowError(buyNowPurchase,button.dataset.uncertainMessage,false);
    }
  });
  window.addEventListener('pageshow',event=>{
    if(!event.persisted)return;
    buyNowPending=false;
    restoreBuyNow(buyNowPurchase);
    announceBuyNow('');
  });
  root.addEventListener('submit',event=>{
    const purchase=event.target.closest('.mmp-purchase');
    if(purchase&&(buyNowPending||purchase.getAttribute('aria-busy')==='true')){
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },true);
  async function buyNow(button){
    const purchase=button.closest('.mmp-purchase');
    const form=button.form;
    if(!form||!purchase||buyNowPending||button.disabled||purchase.inert||purchase!==root.querySelector('.mmp-purchase'))return;
    if(!form.reportValidity())return;
    const data=new FormData(form);
    const quantity=Number(data.get('quantity')||'0');
    if(!data.get('id')||!Number.isSafeInteger(quantity)||quantity<1)return;
    const errorBox=form.querySelector('[data-mmp-buy-now-error]');
    if(errorBox)errorBox.hidden=true;
    buyNowPending=true;
    buyNowPurchase=purchase;
    purchase.inert=true;
    purchase.setAttribute('aria-busy','true');
    button.disabled=true;
    button.setAttribute('aria-busy','true');
    button.textContent=button.dataset.loadingLabel;
    announceBuyNow(button.dataset.loadingLabel);
    const attempt={active:true,confirmed:false};
    buyNowAttempt=attempt;
    let navigating=false;
    let rejectionMessage;
    const addController=new AbortController();
    const timeout=setTimeout(()=>addController.abort(),20000);
    try{
      const response=await fetch(button.dataset.cartAddUrl,{method:'POST',body:data,headers:{Accept:'application/json'},credentials:'same-origin',signal:addController.signal});
      const result=await response.json().catch(()=>null);
      if(!response.ok){
        if(response.status>=400&&response.status<500&&typeof result?.description==='string')rejectionMessage=result.description;
        throw new Error('Cart add failed');
      }
      if(!result||String(result.variant_id||result.id)!==String(data.get('id')))throw new Error('Cart add not confirmed');
      attempt.confirmed=true;
      if(!attempt.active||!root.isConnected||purchase!==root.querySelector('.mmp-purchase'))return;
      window.location.assign(button.dataset.checkoutUrl);
      navigating=true;
    }catch(error){
      if(!attempt.active)return;
      buyNowUncertain=true;
      restoreBuyNow(purchase);
      announceBuyNow('');
      showBuyNowError(purchase,rejectionMessage?`${rejectionMessage} ${button.dataset.uncertainMessage}`:button.dataset.uncertainMessage,true);
    }finally{
      clearTimeout(timeout);
      if(buyNowAttempt===attempt&&!navigating)buyNowPending=false;
    }
  }
  function syncAcceleratedValidity(purchase){
    const form=purchase?.querySelector('.mmp-form');
    const accelerated=form?.querySelector('.mmp-accelerated-checkout');
    if(!accelerated)return;
    const valid=[...form.elements].every(field=>!field.willValidate||field.validity.valid);
    accelerated.inert=!valid;
    accelerated.setAttribute('aria-disabled',String(!valid));
  }
  function initAcceleratedCheckout(purchase){
    if(!purchase?.querySelector('.mmp-accelerated-checkout'))return;
    if(typeof window.Shopify?.PaymentButton?.init==='function')window.Shopify.PaymentButton.init();
    purchase.querySelector('[name=id]')?.dispatchEvent(new Event('change',{bubbles:true}));
    purchase.querySelector('[name=quantity]')?.dispatchEvent(new Event('change',{bubbles:true}));
    syncAcceleratedValidity(purchase);
  }
  ['input','change'].forEach(type=>root.addEventListener(type,event=>{
    if(event.target.closest('.mmp-form'))syncAcceleratedValidity(event.target.closest('.mmp-purchase'));
  }));
  initBuyNow(root.querySelector('.mmp-purchase'));
  initAcceleratedCheckout(root.querySelector('.mmp-purchase'));
  const panels=[...root.querySelectorAll('[data-media-id]')];
  const thumbs=[...root.querySelectorAll('[data-gallery-target]')];
  function showMedia(id){
    const index=panels.findIndex(panel=>panel.dataset.mediaId===String(id));
    if(index<0)return;
    const deferred=panels[index].querySelector('template[data-deferred-media]');
    if(deferred)deferred.replaceWith(deferred.content.cloneNode(true));
    panels.forEach((panel,i)=>{panel.hidden=i!==index;if(i!==index)panel.querySelectorAll('video').forEach(video=>video.pause());});
    thumbs.forEach((thumb,i)=>{if(i===index)thumb.setAttribute('aria-current','true');else thumb.removeAttribute('aria-current');});
    const count=root.querySelector('[data-gallery-count]');if(count)count.textContent=`${index+1} / ${panels.length}`;
  }
  root.addEventListener('click',async event=>{
    const buyButton=event.target.closest('[data-mmp-buy-now]');
    if(buyButton){event.preventDefault();await buyNow(buyButton);return;}
    const thumb=event.target.closest('[data-gallery-target]');if(thumb){showMedia(thumb.dataset.galleryTarget);return;}
    const step=event.target.closest('[data-gallery-step]');if(step){const index=panels.findIndex(panel=>!panel.hidden);showMedia(panels[(index+Number(step.dataset.galleryStep)+panels.length)%panels.length].dataset.mediaId);return;}
    const zoom=event.target.closest('[data-zoom-src]');if(zoom){const dialog=root.querySelector('.mmp-zoom');dialog.querySelector('img').src=zoom.dataset.zoomSrc;dialog.querySelector('img').alt=zoom.querySelector('img')?.alt||'';dialog.showModal();return;}
    if(event.target.closest('[data-zoom-close]')){root.querySelector('.mmp-zoom').close();return;}
    const choice=event.target.closest('[data-mmp-option]');if(!choice||event.ctrlKey||event.metaKey||event.shiftKey)return;
    event.preventDefault();
    if(buyNowPending)return;
    const targetUrl=new URL(choice.href,window.location.origin);
    if(targetUrl.origin!==window.location.origin||targetUrl.pathname!==root.dataset.productUrl){window.location.assign(targetUrl.href);return;}
    if(controller)controller.abort();const requestController=new AbortController();controller=requestController;
    const purchase=root.querySelector('.mmp-purchase');
    const quantity=purchase.querySelector('[name=quantity]')?.value||'1';
    purchase.setAttribute('aria-busy','true');purchase.inert=true;purchase.querySelector('[name=add]').disabled=true;
    const focusId=choice.dataset.optionValueId;
    try{
      const requestUrl=new URL(targetUrl);requestUrl.searchParams.set('section_id',root.dataset.sectionId);
      const response=await fetch(requestUrl,{signal:requestController.signal,credentials:'same-origin'});if(!response.ok)throw new Error('Variant request failed');
      const html=await response.text();if(requestController!==controller||requestController.signal.aborted)return;const nextDoc=new DOMParser().parseFromString(html,'text/html');const nextPurchase=nextDoc.querySelector('.mmp-purchase');if(!nextPurchase)throw new Error('Variant form missing');
      const nextQuantity=nextPurchase.querySelector('[name=quantity]');
      if(nextQuantity&&Number.isInteger(Number(quantity))&&Number(quantity)>0){
        const defaultQuantity=nextQuantity.value;
        nextQuantity.value=quantity;
        if(!nextQuantity.validity.valid)nextQuantity.value=defaultQuantity;
      }
      purchase.replaceWith(nextPurchase);
      initBuyNow(nextPurchase);
      initAcceleratedCheckout(nextPurchase);
      const status=root.querySelector('[data-variant-status]');if(status)status.textContent=nextPurchase.dataset.variantAnnouncement;
      if(nextPurchase.dataset.featuredMedia)showMedia(nextPurchase.dataset.featuredMedia);
      const focus=nextPurchase.querySelector(`[data-option-value-id="${CSS.escape(focusId)}"]`);if(focus){const closed=focus.closest('details:not([open])');(closed?.querySelector('summary')||focus).focus({preventScroll:true});}
      const visibleUrl=new URL(targetUrl);if(nextPurchase.dataset.variantId){visibleUrl.searchParams.delete('option_values');visibleUrl.searchParams.set('variant',nextPurchase.dataset.variantId);}history.replaceState({},'',visibleUrl);
    }catch(error){if(requestController===controller&&!requestController.signal.aborted&&error.name!=='AbortError')window.location.assign(targetUrl.href);}
  });
  const dialog=root.querySelector('.mmp-zoom');dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
}
document.querySelectorAll('[data-mmp]').forEach(initMemeProduct);
document.addEventListener('shopify:section:load',event=>{event.target.querySelectorAll('[data-mmp]').forEach(initMemeProduct);});

